/* ==========================================================================
   main-page.js — page content section (policy / legal / plain pages)
   Builds the "On this page" table of contents from the page's Heading 2s,
   highlights the heading being read, and wraps each heading's text so the
   numbered style works with any text the merchant writes.
   Ported from the mockup's initArticle() (table-of-contents part).
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;

  const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  ZC.mount((root) => {
    ZC.$$('[data-main-page]', root).forEach((section) => {
      if (!ZC.once(section, 'main-page')) return;
      const prose = ZC.$('.aprose', section);
      const grid = ZC.$('.abody__grid', section);
      const aside = ZC.$('[data-toc-aside]', section);
      if (!prose) return;

      // give every H2 an id and keep its text in one element (the number is drawn in front of it)
      const heads = ZC.$$('h2', prose);
      const used = {};
      heads.forEach((h, i) => {
        const text = h.textContent.trim();
        if (!h.id) {
          let id = slug(text) || 'section-' + (i + 1);
          if (used[id]) id += '-' + (i + 1);
          h.id = id;
        }
        used[h.id] = true;
        if (!h.querySelector(':scope > .aprose__title')) {
          const wrap = document.createElement('span');
          wrap.className = 'aprose__title';
          while (h.firstChild) wrap.appendChild(h.firstChild);
          h.appendChild(wrap);
        }
      });

      const toc = ZC.$('[data-toc]', section);
      const list = ZC.$('[data-toc-list]', section);
      if (!aside || !toc || !list || !heads.length) {
        if (aside) aside.hidden = true;
        if (grid) grid.classList.add('abody__grid--solo');
        return;
      }

      list.textContent = '';
      const links = heads.map((h, i) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.setAttribute('data-toc-link', '');
        const n = document.createElement('span');
        n.textContent = String(i + 1).padStart(2, '0');
        a.appendChild(n);
        a.appendChild(document.createTextNode(ZC.$('.aprose__title', h).textContent.trim()));
        li.appendChild(a);
        list.appendChild(li);
        return a;
      });
      aside.hidden = false;

      const update = () => {
        let cur = null;
        const line = window.innerHeight * 0.3;
        heads.forEach((h) => { if (h.getBoundingClientRect().top <= line) cur = h.id; });
        links.forEach((a) => {
          if (a.getAttribute('href') === '#' + cur) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      };
      let tick = false;
      window.addEventListener('scroll', () => {
        if (!tick) { tick = true; requestAnimationFrame(() => { update(); tick = false; }); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();

      // table of contents: open on desktop, collapsed on smaller screens
      const mq = window.matchMedia('(min-width: 1100px)');
      const sync = () => { if (mq.matches) toc.setAttribute('open', ''); else toc.removeAttribute('open'); };
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
      const title = ZC.$('.toc__title', toc);
      if (title) title.addEventListener('click', (e) => { if (mq.matches) e.preventDefault(); });
      links.forEach((a) => a.addEventListener('click', () => { if (!mq.matches) toc.removeAttribute('open'); }));
    });
  });
})();
